import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Surge accountability setting.
 */
export const schema = z.boolean();

export type PassthroughRideshareSurges = z.infer<typeof schema>;

export const definition = define({
  key: 'passthrough_rideshare_surges',
  schema,
  label: 'Surge Charge Accountability',
  description:
    'Activate/Deactivate rideshare surge charges for this client. Surge charges are incurred when the actual rideshare cost is higher than anticipated. When active, the client will cover any rideshare surge charges related to their moves. When inactive, HopDrive will cover the extra cost and waive all rideshare surge charges for this client.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.PRICING.key,
  writableAtLevels: [LEVELS.HOPDRIVE, LEVELS.ORGANIZATION, LEVELS.CUSTOMER, LEVELS.RATERULEGROUP],
  readableByRoles: [ROLES.ADMIN],
  defaultValue: true,
});
